import React from "react";
import sectionCarpet from "../../../assets/section-carpet.png";

const PromotionSection = () => {
  return (
    <div className="mt-16 md:mt-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="relative rounded-2xl overflow-hidden">
        {/* Görsel */}
        <img
          src={sectionCarpet}
          alt="Halı Temizleme"
          className="w-full h-64 md:h-80 object-cover"
        />

        {/* Bilgi Kartı - Küçükte altta, md ve üzerinde sağda absolute */}
        <div className="relative text-center p-6 bg-[#4F46E5] text-white md:absolute md:right-8 md:top-1/2 md:-translate-y-1/2 md:bg-[#4F46E5] md:rounded-2xl md:p-8 md:text-center md:max-w-sm lg:max-w-md">
          <h2 className="text-xl md:text-2xl font-medium mb-2">
            İlk Siparişinize Özel
          </h2>
          <div className="text-3xl md:text-4xl font-bold mb-4">%10 İNDİRİM</div>
          <p className="text-sm opacity-90 max-w-xs mx-auto">
            Hedeflenen profesyonel ekip ve modern ekipmanlarla derinlemesine
            temizlik. İş günkü parlaklığına kavuşuyor.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PromotionSection;
